export default __webpack_public_path__ + "ba975452fc1ce6d0213f08a7d6128c13.svg";